import { getMessagesControl } from 'providers/Toast';

export const MESSAGES = getMessagesControl({
  changeSuccess: (t) => ({
    title: t('project-expected-date-changed'),
    type: 'success',
  }),

  changeRejectSuccess: (t) => ({
    title: t('project-expected-date-was-not-changed'),
    type: 'success',
  }),
});
